package com.yendo.mx.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLDivElement

@Composable
actual fun MapaYendo(
    modifier: Modifier,
    latNegocio: Double,
    lngNegocio: Double,
    latEntrega: Double?,
    lngEntrega: Double?,
    nombreNegocio: String,
    latRepartidor: Double?,
    lngRepartidor: Double?,
    esModoSatelite: Boolean
) {
    DisposableEffect(latNegocio, lngNegocio, latEntrega, lngEntrega, latRepartidor, lngRepartidor) {
        val mapDiv = document.createElement("div") as HTMLDivElement
        mapDiv.id = "gmap-overlay-yendo"
        mapDiv.style.position = "fixed"
        mapDiv.style.bottom = "20px"
        mapDiv.style.right = "20px"
        mapDiv.style.width = "380px"
        mapDiv.style.height = "240px"
        mapDiv.style.borderRadius = "16px"
        mapDiv.style.boxShadow = "0 8px 24px rgba(0,0,0,0.3)"
        mapDiv.style.zIndex = "1000"

        document.body?.appendChild(mapDiv)

        try {
            val google = window.asDynamic().google
            if (google != undefined && google.maps != undefined) {
                val mapOptions = js("{}")
                mapOptions.center = js("({ lat: latNegocio, lng: lngNegocio })")
                mapOptions.zoom = 15
                mapOptions.mapTypeId = if (esModoSatelite) "hybrid" else "roadmap"

                val map = js("new google.maps.Map(mapDiv, mapOptions)")
                val bounds = js("new google.maps.LatLngBounds()")

                // 1. Marcador del Comercio 🏪
                val negocioPos = js("({ lat: latNegocio, lng: lngNegocio })")
                js("new google.maps.Marker({ position: negocioPos, map: map, title: nombreNegocio })")
                bounds.extend(negocioPos)

                // 2. Marcador de Entrega 🏠
                if (latEntrega != null && lngEntrega != null) {
                    val entregaPos = js("({ lat: latEntrega, lng: lngEntrega })")
                    js("new google.maps.Marker({ position: entregaPos, map: map, title: 'Destino' })")
                    bounds.extend(entregaPos)
                }

                // 3. Marcador del Repartidor 🛵
                if (latRepartidor != null && lngRepartidor != null) {
                    val repartidorPos = js("({ lat: latRepartidor, lng: lngRepartidor })")
                    js("new google.maps.Marker({ position: repartidorPos, map: map, title: 'Repartidor' })")
                    bounds.extend(repartidorPos)
                }

                map.fitBounds(bounds)
            }
        } catch (e: Throwable) {
            println("YENDO_WEB: Error cargando Google Maps Yendo -> ${e.message}")
        }

        onDispose {
            mapDiv.remove()
        }
    }

    Box(
        modifier = modifier
            .fillMaxWidth()
            .height(260.dp)
            .background(Color(0xFF232A34), shape = RoundedCornerShape(16.dp)),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.padding(16.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Text(
                "🗺️ Mapa en Vivo (Google Maps)",
                color = Color.White,
                fontWeight = FontWeight.Bold,
                fontSize = 16.sp
            )

            Card(
                colors = CardDefaults.cardColors(containerColor = Color(0xFF1B2028)),
                shape = RoundedCornerShape(12.dp)
            ) {
                Column(
                    modifier = Modifier.padding(12.dp),
                    verticalArrangement = Arrangement.spacedBy(6.dp)
                ) {
                    Text("🏪 Negocio: $nombreNegocio", color = Color.White, fontWeight = FontWeight.Medium)
                    if (latEntrega != null && lngEntrega != null) {
                        Text("🏠 Destino configurado", color = Color(0xFF8E9BAE))
                    }
                    if (latRepartidor != null && lngRepartidor != null) {
                        Text("🛵 Repartidor en ruta ($latRepartidor, $lngRepartidor)", color = Color(0xFF00E676), fontWeight = FontWeight.Bold)
                    } else {
                        Text("⏳ Asignando repartidor...", color = Color(0xFFFFB74D))
                    }
                }
            }
        }
    }
}
